import { ProductEntry, SubscriptionInfoContainer } from '../../../store/api';
import { formatUsageLimit } from '../../../shared/utils/formatUsageLimit';
import { ExtendedRenewalIndividual } from '../utils/renewalTableTileTypes';
import { mapExtendedNextYearRenewalLine } from './mapNextYearRenewalLine';
import { mapIssueUsageIndividual } from '../../../shared/subscription-management/mappings/mapIssueUsage';
import { ExtendedManageLineUsageLimit } from '../../../shared/subscription-management/types/ExtendedManageLineShared';
import { issueNotDeliveredYet } from '../../../shared/subscription-management/types/IssueUsage';
import i18n from '../../../../i18n';

export const mapExtendedIndividual = (
    item: ProductEntry,
    updateRenewalLine,
    spocCurrency: string
): ExtendedRenewalIndividual => {
    const { currentSubscriptions, currentIssueStatistics, previousIssueStatistics } = item;

    return {
        currentYearSubscription:
            currentSubscriptions && currentSubscriptions.individualUsageLimit != null
                ? {
                      type: ExtendedManageLineUsageLimit.Value,
                      label: formatUsageLimit(currentSubscriptions.individualUsageLimit),
                      stockDetails: currentSubscriptions.stockDetails.individual!
                  }
                : {
                      type: ExtendedManageLineUsageLimit.None,
                      label: i18n.t('shop.subscriptions.noIndividualSubscription')
                  },

        nextYearRenewalLine: mapExtendedNextYearRenewalLine(item, spocCurrency, updateRenewalLine),

        previousIssueUsage: hasSubscription(currentSubscriptions)
            ? previousIssueStatistics.individual
                ? mapIssueUsageIndividual(previousIssueStatistics.individual)
                : issueNotDeliveredYet
            : undefined,

        currentIssueUsage: hasSubscription(currentSubscriptions)
            ? currentIssueStatistics.individual
                ? mapIssueUsageIndividual(currentIssueStatistics.individual)
                : issueNotDeliveredYet
            : undefined
    };
};

const hasSubscription = (subscription?: SubscriptionInfoContainer) => subscription?.individualUsageLimit != null;
